import { useEffect, useState } from "react";

import { ArrowButton, Button } from "@king-ict/eupisi-ui/components";
import { hrDate } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import { getKnowledgeCheckById } from "../../api/nisooApi";
import StaticField from "../../components/StaticField";
import { KnowledgeCheck } from "../../models/KnowledgeCheck";
import { RoleEnum } from "../../models/User/RoleEnum";
import { useGetUserSessionQuery } from "../../queries/userQuery";
import { codebookRouteKnowledgeCheck } from "../../routes/routes";
import styles from "./RequestCodeBook.module.scss";

export default function CodeBookKnowledgeCheckDetails(): JSX.Element {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { data: userSession } = useGetUserSessionQuery();
  const userCanEditData = userSession && (userSession.roleId === RoleEnum.CASAdmin || userSession.roleId === RoleEnum.CASManager 
    || userSession.roleId === RoleEnum.ASOOManager || userSession.roleId === RoleEnum.Helpdesk);

  const [knowledgeCheck, setKnowledgeCheck] = useState<KnowledgeCheck>();

  useEffect(() => {
    if (!location || !location.state || !(location.state as any).knowledgeCheckId) {
      return
    }
    const getKnowledgeCheck = async () => {
      var result = await getKnowledgeCheckById((location.state as any).knowledgeCheckId);
      setKnowledgeCheck(result);
    }
    getKnowledgeCheck();
  }, [location]);

  const navigateToEdit = (item: KnowledgeCheck) => {
    history.push(
      codebookRouteKnowledgeCheck(),
      {
        page: "edit",
        knowledgeCheckId: item.id
      }
    );
  }

  const navigateToList = () => {
    history.push(
      codebookRouteKnowledgeCheck(),
      {
        page: "list"
      }
    );
  }

  return (
    <>
      {knowledgeCheck &&
        <>
          <Row>
            <Col md={9}>
              <ArrowButton backwards ariaLabel="" onClick={navigateToList} />
              <span className={styles.backButtonCaption}>
                {t("codeBook.returnToList")}
              </span>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col md={8}>
              <h3>{t("codeBook.knowledgeCheck")}</h3>
            </Col>
            {userCanEditData &&
              <Col md={4} className="d-flex justify-content-end align-items-center">
                <Button onClick={() => navigateToEdit(knowledgeCheck)}>
                  {t("common.edit")}
                </Button>
              </Col>
            }
          </Row>
          <Row className="mt-5">
            <Col md={4} >
              <StaticField
                label={t("common.name")}
                value={knowledgeCheck.name}
              />
            </Col>
            <Col md={4} >
              <StaticField
                label={t("common.dateTo")}
                value={knowledgeCheck.dateTo ? hrDate(knowledgeCheck.dateTo) : ""}
              />
            </Col>
          </Row>
        </>
      }
    </>
  );
}